export const FETCH_GET_COMPLETED_TASK_BY_ID_REQUEST = 'FETCH_GET_COMPLETED_TASK_BY_ID_REQUEST'
export const FETCH_GET_COMPLETED_TASK_BY_ID_SUCCESS = 'FETCH_GET_COMPLETED_TASK_BY_ID_SUCCESS'
export const FETCH_GET_COMPLETED_TASK_BY_ID_FALUIRE = 'FETCH_GET_COMPLETED_TASK_BY_ID_FALUIRE'
